import { useEffect, useState } from 'react';
import './ReviewStack.css'
import ReviewCard from './ReviewCard';

import { createClient } from '@supabase/supabase-js';

const { v4: uuidv4 } = require('uuid');

const supabaseUrl = 'https://hsqjrdifsnxrkwyehhey.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhzcWpyZGlmc254cmt3eWVoaGV5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mjk2NDgxMTQsImV4cCI6MjA0NTIyNDExNH0.PACJoo6iCmukz6LXGtDCfKwv2dUfzv1rI3FWw1DD3P0'
const supabase = createClient(supabaseUrl, supabaseKey)

const ReviewStack = (props) => {
    const [earned, setEarned] = useState(0);
    const [designs, setDesigns] = useState(undefined);
    const [givenSet, setGivenSet] = useState(undefined);

    const [limit, setLimit] = useState(100);
    const [dataPointer, setDataPointer] = useState(0);

    const [currentDesign, setCurrentDesign] = useState(undefined);

    const [noData, setNoData] = useState(false);

    const uploadDesigns = async () => {
        const designs = await supabase
            .from('designs') // Replace with your table name
            .select('*') // Select all columns (or specify specific ones)
            .gt('credits', 0)
            .order('last_claimed', { ascending: true }) // Sort by 'created_at' in descending order
            .limit(limit);
        console.log(designs.data);
        if (designs.data.length == 0) {
            setNoData(true);
        }
        else {
            setDesigns(designs.data);
            // getNextDesign();
        }
    }

    const initializeSet = async () => {
        const { data } = await supabase
            .from('vibe_checks') // Replace with your table name
            .select('*') // Select all columns (or specify specific ones)
            .eq('from', props.design)
        const newSet = new Set();
        newSet.add(props.design);
        data.map((data) => {
            newSet.add(data.design_id);
        })
        console.log(newSet);
        setGivenSet(newSet);
    }

    const getNextDesign = () => {
        if (givenSet) {
            let pointer = dataPointer;
            while (designs[pointer] && givenSet.has(designs[pointer].id) || pointer == limit) {
                pointer++;
            }
            if (!designs[pointer] || givenSet.has(designs[pointer])) {
                setNoData(true);
            }
            else if (!givenSet.has(designs[pointer].id) && pointer < limit) {
                console.log('doing');
                console.log(designs[pointer].id);
                setDataPointer(pointer);
                setCurrentDesign(designs[pointer]);
            }
            else if (pointer == limit) {
                setLimit(limit + 100);
            }
        }
    }

    useEffect(() => {
        if (dataPointer == limit) {
            setLimit(limit + 100);
            setDataPointer(0);
            uploadDesigns();
        }
    }, [dataPointer])

    useEffect(() => {
        if (designs) {
            getNextDesign();
        }
    }, [designs, givenSet])

    useEffect(() => {
        initializeSet();
    }, [])

    useEffect(() => {
        uploadDesigns();
    }, [])

    useEffect(() => {
        if (earned % 6 == 0 && earned != 0) {
            props.earned5();
            setEarned(0);
            // uploadDesigns();
        }
    }, [earned])

    const send = async (vibe, rating, design_id) => {
        const { data } = await supabase
            .from('designs') // Replace with your table name
            .select('*') // Select all columns (or specify specific ones)
            .eq('id', design_id) // Filter by the ID
            .single();
        await supabase
            .from('designs')
            .update({
                vibe_checks_num: data.vibe_checks_num + 1,
                rates_sum: data.rates_sum + rating,
                credits: data.credits - 1
            })
            .match({ id: data.id });
        await supabase
            .from('vibe_checks')
            .insert([
                {
                    id: uuidv4(),
                    rate: rating,
                    vibe: vibe,
                    design_id: design_id,
                    from: props.design
                }
            ])
            .then(() => {
                const newSet = new Set(givenSet);
                newSet.add(currentDesign.id); // Add the new id
                setGivenSet(newSet);
                setEarned(earned + 1);
            });
    }

    const getWidth = () => {
        switch (earned) {
            case 0: return '10%';
            case 1: return '25%';
            case 2: return '40%';
            case 3: return '55%';
            case 4: return '70%';
            case 5: return '85%';
        }
    }
    return (
        <div className='stack_container'>
            <div className='stack_indicator' style={{
                width: getWidth()
            }}></div>
            {currentDesign && !noData &&
                <ReviewCard design={currentDesign} send={send} />
            }
            {noData &&
                <div>Nothing to review, please return later</div>
            }
        </div>
    )
}

export default ReviewStack;